import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 text-gray-400 p-4 text-center text-sm">
      © 2025 Mi Empresa. Todos los derechos reservados.
    </footer>
  );
};

export default Footer;
